import { render, staticRenderFns } from "./PerfilAdmin.vue?vue&type=template&id=281336f2"
import script from "./PerfilAdmin.vue?vue&type=script&lang=js"
export * from "./PerfilAdmin.vue?vue&type=script&lang=js"
import style0 from "./PerfilAdmin.vue?vue&type=style&index=0&id=281336f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports